/*
 * @message:
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-06-30 17:03:18
 * @FilePath: \mrc-ess-fronted\src\store\index.js
 * @最后编辑: Betway
 * @最后修改时间: 2022-03-09 11:12:55
 */

import Vue from "vue";
import Vuex from "vuex";
import Cookies from "js-cookie";
import _this from "../main.js";
import { setup_locale } from "@/util/lang";
import { Request } from "@/api/api";
import { aesEncrypt } from "@/util/func";
Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    isLoading: false, //全局api请求过程
    isDemo: Cookies.get("mrc-ess-debug-mode-demo") === "true" || false, //演示模式
    viewkey: Cookies.get("mrc-view-keys-open") === "true" || false, //查看key模式
    curNavKey: localStorage.getItem("mrc-ess-menus-navigation-key") || "", //记录当前路由，刷新之后定位到当前菜单
    curBaseKey: Cookies.get("mrc-ess-menus-navigation-base-key") || "", //记录仪表板的路由，重新登录后的默认菜单，比如token失效后重新登录
    MessageList:
      window.localStorage.getItem("mrc-ess-tools-notification-message-lists") ||
      "", //消息列表，暂废弃此功能
    userToken:
      localStorage.getItem("mrc-ess-base-application-user-token") || "", //token
    userInfo: Cookies.get("mrc-ess-base-application-user-info") || "", //记录登录信息，信息已经加密
    AppInfo: localStorage.getItem("mrc-ess-base-application-info") || "", //登录完成后保存系统信息，logo，用户名等等
    companyLogo: localStorage.getItem("mrc-ess-base-company-logo-url") || "", //公司logo
    staticZone: [],
    isNeedSpace:
      localStorage.getItem("mrc-ess-base-application-default-lang") &&
      localStorage
        .getItem("mrc-ess-base-application-default-lang")
        .toString() === "en", //是否需要翻译之间的空格
    FunctionUuid:
      localStorage.getItem("mrc-ess-menus-mode-function-uuid") || "", //功能uuid，用以获取按钮权限的重要参数
    pageTriger: false, //激活页面验证
    isChanged:
      localStorage.getItem("mrc-ess-tools-page-current-changed") || false, //监听页面变化，做警告提示
    // 默认语言
    defaultLang:
      localStorage.getItem("mrc-ess-base-application-default-lang") ||
      localStorage.setItem("mrc-ess-base-application-default-lang", "en"), //全局默认语言
    allLangLabel:
      JSON.parse(localStorage.getItem("mrc-ess-base-lang-object-labels")) || [], // 语言所有label翻译
    companyLang:
      JSON.parse(localStorage.getItem("mrc-ess-base-company-lang-lists")) || [], // 当前打开界面有几种语言可选
    showLang: "", //当前展示语言
    defaultUTC: Cookies.get("mrc-ess-base-application-default-utc") || 480, //全局默认时区
    tablerReset:
      localStorage.getItem("mrc-ess-components-table-reset-key") || "",
    loginEncryptKey: localStorage.getItem("mrc-ess-login-encrypt-key") || "",
    SelectionRefresh: 1,
    MsgStatus: {
      color: "",
      text: "",
      show: false,
    }, //底部提示信息
    SYSTEM_STATUS:
      localStorage.getItem("mrc-ess-base-pages-routers-status") || 0, //当前系统状态
    clientMode: localStorage.getItem("mrc-ess-base-client-params-mode") || 1,
  },
  mutations: {
    SET_CLIENT_MODE: (state, mode) => {
      state.clientMode = mode;
      localStorage.setItem("mrc-ess-base-client-params-mode", mode);
    },
    SET_SYSTEM_STATUS: (state, status) => {
      state.SYSTEM_STATUS = status;
      localStorage.setItem("mrc-ess-base-pages-routers-status", status);
    },
    SET_FUNCTIONUUID: (state, FunctionUuid) => {
      state.FunctionUuid = FunctionUuid;
      localStorage.setItem("mrc-ess-menus-mode-function-uuid", FunctionUuid);
    },
    SET_LOGINENCRYPTKEY: (state, key) => {
      state.loginEncryptKey = key;
      localStorage.setItem("mrc-ess-login-encrypt-key", key);
    },
    SelectionRefresh: (state, val) => {
      state.SelectionRefresh = val;
    },
    RESET_TABLE: (state, val) => {
      state.tablerReset = val;
      localStorage.setItem("mrc-ess-components-table-reset-key", val);
    },
    SET_PAGECHANGE: (state, change) => {
      localStorage.setItem("mrc-ess-tools-page-current-changed", change);
      state.isChanged = change;
    },
    SET_DEMO: (state, demo) => {
      Cookies.set("mrc-ess-debug-mode-demo", demo, { expires: 7 });
      state.isDemo = demo;
    },
    SET_VIEWKEY: (state, view) => {
      localStorage.setItem("mrc-view-keys-open", view);
      state.viewkey = view;
    },
    SET_LOGO: (state, logo) => {
      localStorage.setItem("mrc-ess-base-company-logo-url", logo);
      state.companyLogo = logo;
    },
    SET_NAVKEY: (state, nav_key) => {
      localStorage.setItem("mrc-ess-menus-navigation-key", nav_key);
      state.curNavKey = nav_key;
    },
    SET_BASEKEY: (state, base_key) => {
      Cookies.set("mrc-ess-menus-navigation-base-key", base_key);
      state.curBaseKey = base_key;
    },
    SET_LOADING: (state, loading) => {
      if (!loading) {
        setTimeout(() => {
          state.isLoading = loading;
        }, 500);
      } else state.isLoading = loading;
    },
    SET_PAGETRIGER: (state, pageTriger) => {
      state.pageTriger = pageTriger;
    },
    SET_MESSAGELIST: (state, MessageList) => {
      state.MessageList = MessageList;
      localStorage.setItem(
        "mrc-ess-tools-notification-message-lists",
        MessageList
      );
    },
    SET_TOKEN: (state, token) => {
      state.userToken = token;
      localStorage.setItem("mrc-ess-base-application-user-token", token);
    },
    SET_DEFAULTLANG: (state, defaultLang) => {
      state.defaultLang = defaultLang;
      state.isNeedSpace = defaultLang.toString() === "en";
      state.companyLang.forEach((item) => {
        if (item.value == defaultLang) {
          item.is_default = 1;
          localStorage.setItem(
            "mrc-ess-base-application-default-lang",
            item.value
          );
          //  Cookies.set("mrc-ess-base-application-default-lang", item.value, { expires: 7 });
        } else {
          item.is_default = 0;
        }
      });
      // 排序，将默认语言排在最前面
      state.companyLang.sort((a, b) => {
        if (a.is_default > b.is_default) {
          return -1;
        } else if (a.is_default == b.is_default) {
          return 0;
        } else {
          return 1;
        }
      });
      localStorage.setItem(
        "mrc-ess-base-company-lang-lists",
        JSON.stringify(state.companyLang)
      );
      if (!defaultLang) {
        state.showLang = "English";
      } else {
        state.showLang = state.companyLang.filter(
          (item) => item.value == defaultLang
        )[0].text;
      }
      setup_locale(defaultLang);
      if (
        state.userToken &&
        localStorage.getItem("mrc-ess-base-application-user-token")
      ) {
        // 通知后端修改语言，用于错误信息翻译
        Request({
          method: "POST",
          table: "mrbase_sys_language_master",
          url: "/user/language/update-language/",
          data: {
            language_code: defaultLang,
          },
          type: "lang",
          global: false,
        });
      }
    },
    SET_DEFAULTUTC: (state, defaultUTC) => {
      state.defaultUTC = defaultUTC;
      Cookies.set("mrc-ess-base-application-default-utc", defaultUTC, {
        expires: 7,
      });
    },
    SHOW_MESSAGE: (state, msgstatus) => {
      state.MsgStatus.show = true;
      state.MsgStatus.color = msgstatus.color;
      state.MsgStatus.text = msgstatus.text;
    },
    HIDE_MESSAGE: (state) => {
      state.MsgStatus.show = false;
      state.MsgStatus.color = "";
      state.MsgStatus.text = "";
    },
    SET_USERINFO: (state, userInfo) => {
      state.userInfo = userInfo;
      Cookies.set("mrc-ess-base-application-user-info", userInfo, {
        expires: 7,
      });
    },
    SET_APPINFO: (state, AppInfo) => {
      state.AppInfo = AppInfo;
      localStorage.setItem("mrc-ess-base-application-info", AppInfo);
    },
    SET_COMPANYLANG: (state, companyLang) => {
      state.companyLang = companyLang;
      localStorage.setItem(
        "mrc-ess-base-company-lang-lists",
        JSON.stringify(companyLang)
      );
    },
    SET_ZONE: (state, zone) => {
      state.staticZone = zone;
      // Cookies.set("staticZone", zone, { expires: 7 });
    },
    SET_ALLLANGLABEL: (state, value) => {
      state.allLangLabel = value;
      localStorage.setItem(
        "mrc-ess-base-lang-object-labels",
        JSON.stringify(value)
      );
    },
  },
  actions: {
    setClientMode({ commit }, mode) {
      commit("SET_CLIENT_MODE", mode);
    },
    updateSystemStatus({ commit }, status) {
      commit("SET_SYSTEM_STATUS", status);
    },
    setPageChange({ commit }, change) {
      commit("SET_PAGECHANGE", change);
    },
    resetTable({ commit }, val) {
      commit("RESET_TABLE", val);
    },
    setDemo({ commit }, demo) {
      commit("SET_DEMO", demo);
    },
    setViewKey({ commit }, demo) {
      commit("SET_VIEWKEY", demo);
    },
    setFunctionId({ commit }, fun) {
      commit("SET_FUNCTIONUUID", fun);
    },
    setLogo({ commit }, logo) {
      commit("SET_LOGO", logo);
    },
    setNavKey({ commit }, nav_key) {
      commit("SET_NAVKEY", nav_key);
    },
    setBaseKey({ commit }, base_key) {
      commit("SET_BASEKEY", base_key);
    },
    setLoading({ commit }, loading) {
      commit("SET_LOADING", loading);
    },
    setPageTriger({ commit }, pageTriger) {
      commit("SET_PAGETRIGER", pageTriger);
    },
    setMessageList({ commit }, MessageList) {
      commit("SET_MESSAGELIST", MessageList);
    },
    setToken({ commit }, token) {
      commit("SET_TOKEN", token);
    },
    setDefaultLang({ commit, state }, defaultLang) {
      commit("SET_DEFAULTLANG", defaultLang);
    },
    setDefaultUTC({ commit }, defaultUTC) {
      commit("SET_DEFAULTUTC", defaultUTC);
    },
    showMessage({ commit }, status) {
      commit("SHOW_MESSAGE", status);
    },
    hideMessage({ commit }) {
      commit("HIDE_MESSAGE");
    },
    setUserInfo({ commit }, userInfo) {
      commit("SET_USERINFO", userInfo);
    },
    setAppInfo({ commit }, AppInfo) {
      commit("SET_APPINFO", AppInfo);
    },
    getLoginEncryptKey({ commit, state }) {
      Request({
        method: "POST",
        url: "/rsa/getKey/",
        data: {},
        type: "lang",
        notAlert: true,
      })
        .then((res) => {
          if (res.code == 200) {
            commit("SET_LOGINENCRYPTKEY", res.data);
          }
        })
        .catch((err) => {
          console.error("error occurred during getting key! Error:" + err);
        });
    },
    // 查找该公司有几种国际化语言
    setCompanyLang({ commit, state }, companyLang) {
      let org_uuid = state.AppInfo
        ? JSON.parse(state.AppInfo)["org_level_uuid"]
        : "";
      let url = state.userToken
        ? "/language/list-language-company/"
        : "/language/login-language/";
      Request({
        method: "POST",
        table: "mrbase_sys_language_master",
        url: state.userToken
          ? "/language/list-language-company/"
          : "/language/login-language/",
        data: {
          org_level_uuid: org_uuid,
        },
        type: "lang",
        notAlert: true,
      })
        .then((res) => {
          if (res.code == 200) {
            let arr = res.data;
            //   .filter(
            //   (ele) =>
            //     ele.value == "en" ||
            //     ele.value == "zh-HK" ||
            //     ele.value == "zh-CN"
            // );

            commit("SET_COMPANYLANG", arr);
            let lang = navigator.language || navigator.userLanguage;
            let defLang = state.defaultLang;
            let curLang = arr.find((ele) => ele.value == lang);
            let LangObject = arr.find((ele) => ele.value == defLang);
            if (!LangObject && arr.length) {
              if (!curLang && arr.length) {
                commit("SET_DEFAULTLANG", arr[0]["value"]);
              } else {
                commit("SET_DEFAULTLANG", lang);
              }
            } else {
              commit("SET_DEFAULTLANG", LangObject.value);
            }
          } else {
            commit("SET_COMPANYLANG", []);
          }
        })
        .catch((err) => {
          // console.table({ 'Error': "An error occurred during the acquisition of the organization's language!" ,
          //   'Error Detail': err.msg, 'Error Code': err.code
          // })
          console.error(
            "%cAn error occurred during the acquisition of the organization's language! The detailed error is '" +
              err.msg +
              "'",
            "color: #0f46c1; font-size: 16px"
          );
        });
    },
    setZone({ commit }, zone) {
      commit("SET_ZONE", zone);
    },
    // 查找公司的所有语言label
    async SET_ALLLANGLABEL({ commit, state }) {
      // const res = await getAllLabel({ language_code: value })
      // commit("SET_ALLLANGLABEL", []);
      await new Promise((resolve, reject) => {
        Request({
          method: "POST",
          table: "mrbase_sys_language_values",
          url: "/lable_internationalization/list-label-internation-web/",
          data: {},
          type: "lang",
          notAlert: true,
          notUser: true, //不需要token
        })
          .then((res) => {
            if (res.code == 200) {
              commit("SET_ALLLANGLABEL", res.data);
              resolve(res.data);
            } else {
              commit("SET_ALLLANGLABEL", {});
              resolve({});
            }
          })
          .catch((err) => {
            console.error(
              "%cAn error occurred during the acquisition of the translation data! The detailed error is '" +
                err.msg +
                "'",
              "color: #0f46c1; font-size: 16px"
            );
            // 请求失败
            reject(err);
          });
      });
    },
  },
  modules: {},
  getters: {
    clientMode(state) {
      return state.clientMode;
    },
    SYSTEM_STATUS(state) {
      return state.SYSTEM_STATUS;
    },
    isChanged(state) {
      return state.isChanged;
    },
    SelectionRefresh(state) {
      return state.SelectionRefresh;
    },
    isDemo(state) {
      if (process.env.NODE_ENV == "production") return false;
      return state.isDemo;
    },
    viewkey(state) {
      return state.viewkey;
    },
    tablerReset(state) {
      return state.tablerReset;
    },
    companyLogo(state) {
      return state.companyLogo;
    },
    curNavKey(state) {
      return state.curNavKey;
    },
    curBaseKey(state) {
      return state.curBaseKey;
    },
    isLoading(state) {
      return state.isLoading;
    },
    pageTriger(state) {
      return state.pageTriger;
    },
    MessageList(state) {
      return state.MessageList;
    },
    userToken(state) {
      return state.userToken;
    },
    loginEncryptKey(state) {
      return state.loginEncryptKey;
    },
    showLang(state) {
      const lang = state.companyLang.filter((item) => {
        return item.value == state.defaultLang;
      });
      let text = "";
      if (lang.length > 0) {
        text = lang[0].text;
      }
      return text;
    },
    FunctionUuid(state) {
      return state.FunctionUuid;
    },
    defaultLang(state) {
      return state.defaultLang;
    },
    MsgStatus(state) {
      return state.MsgStatus;
    },
    staticZone(state) {
      return state.staticZone;
    },
    userInfo(state) {
      return state.userInfo;
    },
    AppInfo(state) {
      return state.AppInfo;
    },
    companyLang(state) {
      return state.companyLang;
    },
    defaultUTC(state) {
      return state.defaultUTC;
    },
    isNeedSpace(state) {
      return state.isNeedSpace;
    },
    allLangLabel(state) {
      return state.allLangLabel;
    },
  },
});
export default store;
